export default {"src":"/_next/static/media/eye-off.5c07683f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};